// Mock Data برای Transactions
export interface Transaction {
  id: string;
  type: 'deposit' | 'withdrawal' | 'payment' | 'refund';
  amount: number;
  description: string;
  date: string;
  status: 'completed' | 'pending' | 'failed';
}

export const mockTransactions: Transaction[] = [
  {
    id: '1',
    type: 'deposit',
    amount: 1000000,
    description: 'شارژ کیف پول',
    date: '2024-10-10',
    status: 'completed'
  },
  {
    id: '2',
    type: 'payment',
    amount: -500000,
    description: 'پرداخت رزرو هتل',
    date: '2024-10-09',
    status: 'completed'
  },
  {
    id: '3',
    type: 'refund',
    amount: 200000,
    description: 'بازگشت هزینه لغو شده',
    date: '2024-10-08',
    status: 'completed'
  },
  {
    id: '4',
    type: 'payment',
    amount: -300000,
    description: 'پرداخت رزرو پرواز',
    date: '2024-10-07',
    status: 'pending'
  }
];

export const getMockTransactions = (): Promise<Transaction[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockTransactions);
    }, 300);
  });
};

